// @flow

/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react'
import Infinite from 'react-infinite'
import { connect } from 'react-redux'

import { fetchPollsIntoStore } from '../../sagas/fetchPolls'
import { selectAllPolls, clearPollsStore } from '../../stores/pollsStore'
import { selectIsFetchingPolls } from '../../stores/pending'
import {
  hasMore,
  getLibraryPollKey,
  clearCursors,
} from '../../stores/cursoredUrlsStore'
import { getTagFilters, togglePollFilter } from '../../stores/pollFilters'

import type { Poll, Filter } from '../../types'

import PollItem from './PollItem'
import FilterBox from '../FilterBox'

const ELEMENT_HEIGHT = 50

type Props = {
  polls: Array<Poll>,
  isFetching: boolean,
  fetchPolls: () => void,
  hasMore: boolean,
  tagFilters: Array<Filter>,
  togglePollFilter: Function,
  clearCursors: Function,
  clearPollsStore: Function,
}

// eslint-disable-next-line react/prefer-stateless-function
export class PollList extends Component<Props, { showTagFilters: boolean }> {
  state = {
    showTagFilters: false,
  }

  state: {
    showTagFilters: boolean,
  }

  componentDidMount() {
    this.props.fetchPolls()
  }

  fetchFilteredPolls() {
    this.setState({ showTagFilters: false })
    this.props.clearPollsStore()
    this.props.clearCursors()
    this.props.fetchPolls()
  }

  renderLoading() {
    if (!this.props.hasMore) return null
    return <div className="bold">Loading next polls...</div>
  }

  render() {
    const {
      polls,
      isFetching,
      hasMore,
      fetchPolls,
      tagFilters,
      togglePollFilter,
    } = this.props

    return (
      <div className="poll-list">
        <div className="dt f6 w-100">
          <div className="word-wrap dt-row w-100 bg-op-con-dark white">
            <div className="dtc tc w-5 v-mid pa2"></div>
            <div className="dtc tc w-5 v-mid pa2"></div>
            <div className="dtc w-5 v-mid pa2">Type</div>
            <div className="dtc tl w-40 v-mid pa2">Question</div>
            <div className="dtc w-10 v-mid pa2">Publisher</div>
            <div className="dtc w-10 v-mid pa2">Last Updated</div>
            <div className="dtc w-10 v-mid pa2 relative">
              <div
                className="flex pointer"
                onClick={() =>
                  this.setState({ showTagFilters: !this.state.showTagFilters })
                }
              >
                <span className="mr2">Tags</span>
                <span className="flex flex-column justify-center">
                  <span className="chevron-arrow-up"></span>
                  <span className="chevron-arrow-down"></span>
                </span>
              </div>
              <FilterBox
                className={`${
                  this.state.showTagFilters ? '' : 'dn'
                } absolute left-0 mt2 z-999`}
                filters={tagFilters}
                toggleFilter={togglePollFilter}
                onCancel={() => this.setState({ showTagFilters: false })}
                onFilter={() => this.fetchFilteredPolls()}
              />
            </div>
            <div className="dtc w-20 v-mid pa2 tr"></div>
          </div>
        </div>

        {!polls.length && isFetching ? (
          <div
            className="bg-white w-100 flex items-center ph3"
            style={{ height: ELEMENT_HEIGHT }}
          >
            Loading polls...
          </div>
        ) : (
          <Infinite
            elementHeight={ELEMENT_HEIGHT}
            useWindowAsScrollContainer
            infiniteLoadBeginEdgeOffset={2000}
            onInfiniteLoad={hasMore ? fetchPolls : () => {}}
            isInfiniteLoading={isFetching}
            loadingSpinnerDelegate={this.renderLoading()}
          >
            {polls.map(poll => (
              <PollItem
                elementHeight={ELEMENT_HEIGHT}
                key={poll.id}
                poll={poll}
              />
            ))}
          </Infinite>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const key = getLibraryPollKey(state)
  return {
    polls: selectAllPolls(state),
    isFetching: selectIsFetchingPolls(state),
    hasMore: hasMore(state, key) ? true : false,
    tagFilters: getTagFilters(state),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchPolls: () => dispatch(fetchPollsIntoStore()),
    clearPollsStore: () => dispatch(clearPollsStore()),
    clearCursors: () => dispatch(clearCursors()),
    togglePollFilter: filter => dispatch(togglePollFilter(filter)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PollList)



// WEBPACK FOOTER //
// ./src/components/LibraryPage/PollList.js